import styled from 'styled-components';
import { animated } from 'react-spring';

export const Row = styled(animated.div)`
    display: flex;
`;
